import { useCallback } from 'react'

import { useUpdateUserSkins } from './useUpdateUserSkins'

export const useUpdateUserSpiralSkin = ({
  onSuccess,
}: {
  onSuccess?: () => void
} = {}) => {
  const { loading, handleUpdateUserSkins } = useUpdateUserSkins({
    onSuccess,
  })

  const handleUpdateUserSpiralSkin = useCallback(
    async (spiral: string) => {
      await handleUpdateUserSkins({ spiral })
    },
    [handleUpdateUserSkins]
  )

  return {
    loading,
    handleUpdateUserSpiralSkin,
  }
}
